import About from './containers/about/About';
import { AddPost } from './containers/admin/add_post/AddPost';
import Dashboard from './containers/admin/Dashboard';
import { AuthForm } from './containers/adminLogin/AuthForm';
import { Blog } from './containers/blog/Blog';
import Home from './containers/home/Home';
import { SinglePost } from './containers/singlepost/SinglePost';

export const stableRoute = [
  { id: 1, path: '/', name: 'homepage', component: Home },
  { id: 2, path: '/about', name: 'about', component: About },
  { id: 3, path: '/post', name: 'blog', component: Blog },
  { id: 4, path: '/post/:id', name: 'single-blog page', component: SinglePost },
  { id: 5, path: '/admin', name: 'admin login', component: AuthForm },
];


export const privateRoute = [
  { id: 1, path: '/admin/dashboard', name: 'All Posts', component: Dashboard },
  { id: 2, path: '/admin/dashboard/add-post', name: 'Add Posts', component: AddPost },
];
